<div [ngClass]="buttonColor" *ngIf="!hidden">
    <a *ngIf="!loading; else lodingTemp">
        <ng-content></ng-content>
    </a>
</div>

<ng-template #lodingTemp>
    <a style="display: flex; justify-content: center; align-content: center">
        <app-loading-circle></app-loading-circle>
    </a>
</ng-template>
